import * as vars from "./variables";
export const typeRoles = {
    body: {
        fontFamily: vars.type_body_font_family,
        fontSize: vars.type_body_font_size,
        fontWeight: vars.type_body_font_weight,
        lineHeight: vars.type_body_line_height,
        letterSpacing: vars.type_body_letter_spacing,
        textTransform: vars.type_body_text_transform,
    },
    emphasis: {
        fontFamily: vars.type_emphasis_font_family,
        fontSize: vars.type_emphasis_font_size,
        fontWeight: vars.type_emphasis_font_weight,
        lineHeight: vars.type_emphasis_line_height,
        letterSpacing: vars.type_emphasis_letter_spacing,
        textTransform: vars.type_emphasis_text_transform,
    },
    "body-sm": {
        fontFamily: vars.type_body_sm_font_family,
        fontSize: vars.type_body_sm_font_size,
        fontWeight: vars.type_body_sm_font_weight,
        lineHeight: vars.type_body_sm_line_height,
        letterSpacing: vars.type_body_sm_letter_spacing,
        textTransform: vars.type_body_sm_text_transform,
    },
    "body-xs": {
        fontFamily: vars.type_body_xs_font_family,
        fontSize: vars.type_body_xs_font_size,
        fontWeight: vars.type_body_xs_font_weight,
        lineHeight: vars.type_body_xs_line_height,
        letterSpacing: vars.type_body_xs_letter_spacing,
        textTransform: vars.type_body_xs_text_transform,
    },
    caption: {
        fontFamily: vars.type_caption_font_family,
        fontSize: vars.type_caption_font_size,
        fontWeight: vars.type_caption_font_weight,
        lineHeight: vars.type_caption_line_height,
        letterSpacing: vars.type_caption_letter_spacing,
        textTransform: vars.type_caption_text_transform,
    },
    micro: {
        fontFamily: vars.type_micro_font_family,
        fontSize: vars.type_micro_font_size,
        fontWeight: vars.type_micro_font_weight,
        lineHeight: vars.type_micro_line_height,
        letterSpacing: vars.type_micro_letter_spacing,
        textTransform: vars.type_micro_text_transform,
    },
    label: {
        fontFamily: vars.type_label_font_family,
        fontSize: vars.type_label_font_size,
        fontWeight: vars.type_label_font_weight,
        lineHeight: vars.type_label_line_height,
        letterSpacing: vars.type_label_letter_spacing,
        textTransform: vars.type_label_text_transform,
    },
    overline: {
        fontFamily: vars.type_overline_font_family,
        fontSize: vars.type_overline_font_size,
        fontWeight: vars.type_overline_font_weight,
        lineHeight: vars.type_overline_line_height,
        letterSpacing: vars.type_overline_letter_spacing,
        textTransform: vars.type_overline_text_transform,
    },
    code: {
        fontFamily: vars.type_code_font_family,
        fontSize: vars.type_code_font_size,
        fontWeight: vars.type_code_font_weight,
        lineHeight: vars.type_code_line_height,
        letterSpacing: vars.type_code_letter_spacing,
        textTransform: vars.type_code_text_transform,
    },
    "code-sm": {
        fontFamily: vars.type_code_sm_font_family,
        fontSize: vars.type_code_sm_font_size,
        fontWeight: vars.type_code_sm_font_weight,
        lineHeight: vars.type_code_sm_line_height,
        letterSpacing: vars.type_code_sm_letter_spacing,
        textTransform: vars.type_code_sm_text_transform,
    },
    display: {
        fontFamily: vars.type_display_font_family,
        fontSize: vars.type_display_font_size,
        fontWeight: vars.type_display_font_weight,
        lineHeight: vars.type_display_line_height,
        letterSpacing: vars.type_display_letter_spacing,
        textTransform: vars.type_display_text_transform,
    },
    "title-page": {
        fontFamily: vars.type_title_page_font_family,
        fontSize: vars.type_title_page_font_size,
        fontWeight: vars.type_title_page_font_weight,
        lineHeight: vars.type_title_page_line_height,
        letterSpacing: vars.type_title_page_letter_spacing,
        textTransform: vars.type_title_page_text_transform,
    },
    "title-card": {
        fontFamily: vars.type_title_card_font_family,
        fontSize: vars.type_title_card_font_size,
        fontWeight: vars.type_title_card_font_weight,
        lineHeight: vars.type_title_card_line_height,
        letterSpacing: vars.type_title_card_letter_spacing,
        textTransform: vars.type_title_card_text_transform,
    },
    "title-section": {
        fontFamily: vars.type_title_section_font_family,
        fontSize: vars.type_title_section_font_size,
        fontWeight: vars.type_title_section_font_weight,
        lineHeight: vars.type_title_section_line_height,
        letterSpacing: vars.type_title_section_letter_spacing,
        textTransform: vars.type_title_section_text_transform,
    },
    "title-subsection": {
        fontFamily: vars.type_title_subsection_font_family,
        fontSize: vars.type_title_subsection_font_size,
        fontWeight: vars.type_title_subsection_font_weight,
        lineHeight: vars.type_title_subsection_line_height,
        letterSpacing: vars.type_title_subsection_letter_spacing,
        textTransform: vars.type_title_subsection_text_transform,
    },
    button: {
        fontFamily: vars.type_button_font_family,
        fontSize: vars.type_button_font_size,
        fontWeight: vars.type_button_font_weight,
        lineHeight: vars.type_button_line_height,
        letterSpacing: vars.type_button_letter_spacing,
        textTransform: vars.type_button_text_transform,
    },
};
export const typeRoleNames = Object.keys(typeRoles);
//# sourceMappingURL=typeRoles.js.map